import React from 'react';
import { FaDownload, FaRegClock, FaEllipsisVertical, FaGear, FaPenToSquare, FaCheck, FaXmark, FaCrown, FaChartLine, FaDatabase, FaChartSimple, FaList, FaTable, FaChevronLeft, FaChevronRight, FaCaretUp, FaCaretDown, FaRegTrashCan, FaSquareCheck, FaVolumeHigh, FaBell, FaPalette, FaPuzzlePiece, FaRocket, } from 'react-icons/fa6'; // FontAwesome 6
const ICON_OPTIONS = {
    fontawesome: {
        Clock: FaRegClock,
        Download: FaDownload,
        Ellipsis: FaEllipsisVertical,
        Config: FaGear,
        Edit: FaPenToSquare,
        Check: FaCheck,
        Close: FaXmark,
        LineGraph: FaChartLine,
        BarGraph: FaChartSimple,
        Data: FaDatabase,
        Crown: FaCrown,
        List: FaList,
        Table: FaTable,
        ArrowLeft: FaChevronLeft,
        ArrowRight: FaChevronRight,
        Trash: FaRegTrashCan,
        ArrowUp: FaCaretUp,
        ArrowDown: FaCaretDown,
        CheckSquare: FaSquareCheck,
        Sound: FaVolumeHigh,
        Bell: FaBell,
        Style: FaPalette,
        Integration: FaPuzzlePiece,
        Cross: FaXmark,
        Rocket: FaRocket,
    },
};
const ICON_SOURCE = 'fontawesome';
export const IconSets = ({ name, source = ICON_SOURCE, className, }) => {
    const IconComponent = ICON_OPTIONS[source][name];
    return React.createElement(IconComponent, { className: className });
};
// Export available icon sources for easy reference
export const AVAILABLE_ICON_SOURCES = Object.keys(ICON_OPTIONS);
